import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        linkFeature: {
          module: () => import('./link.module').then((m) => m.LinkModule),
        },
      }
    })
  ]
})
export class LinkFeatureModule {}
